var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03033 0.71875C3.54346 0.71875 0.716797 3.53796 0.716797 7.01562C0.716797 10.4933 3.54346 13.3125 7.03033 13.3125C10.5172 13.3125 13.3439 10.4933 13.3439 7.01562C13.3439 3.53796 10.5172 0.71875 7.03033 0.71875ZM7.03033 3.36833C8.04543 3.36833 8.9635 3.78139 9.62603 4.44753L10.6873 3.69424V7.09172L7.42724 6.00791L8.38754 5.3261C8.01578 5.02784 7.54464 4.84878 7.03035 4.84878C5.83046 4.84878 4.85776 5.81889 4.85776 7.01564C4.85776 8.21238 5.83044 9.18248 7.03033 9.18248C7.8356 9.18248 8.5371 8.74476 8.91236 8.09561L10.1994 8.83352C9.56782 9.92631 8.38586 10.6629 7.03033 10.6629C5.01072 10.6629 3.37338 9.02989 3.37338 7.01562C3.37338 5.00136 5.01072 3.36833 7.03033 3.36833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.72b2a64639cbbb744dff054b741532aa.svg";
export { ForwardRef as ReactComponent };